import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryShowcase() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索韩国伦理的五大维度
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            从传统到现代，从家庭到社会，从制度到文化，全方位解读韩国伦理的深层内涵
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-50 p-6 flex flex-col items-center text-center cursor-pointer transition-all duration-300 hover:-translate-y-1 min-h-[240px]"
            >
              <div
                className="absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-8 transition-opacity duration-500"
                style={{ backgroundImage: `url('${cat.imageUrl}')` }}
              ></div>

              <div className="relative z-10">
                <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                  <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>

                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  {cat.name}
                </h3>

                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-3 mb-4">
                  {cat.description}
                </p>

                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 whitespace-nowrap">
                  {cat.articleCount} 篇文章
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}